import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Api } from 'src/app/services/api';
import { Globals } from 'src/app/services/globals';
import { IPosterOrder, IPosterOrderItem } from '../../../../../../../common/common-interfaces/poster-order';
import moment from 'moment';
import { availableSkuInfoByPosterType } from '../../../../../../../common/common-helpers/sku';

@Component({
    selector: 'poster-orders',
    templateUrl: './poster-orders.component.html',
    styleUrls: ['./poster-orders.component.scss'],
    standalone: false
})
export class PosterOrdersComponent {
  orders: (IPosterOrder & any)[] = [];
  statuses: string[] = ['PENDING', 'READY', 'QUEUED_FOR_PRINT', 'PRINTED', 'SHIPPED', 'DELIVERED', 'CANCELLED', 'ERROR'];
  availableSkuInfoByPosterType = availableSkuInfoByPosterType;
  periodStart: Date;
  periodEnd: Date;

  storeHasFreezeTime: boolean = false;



  orderNumber: string = '';
  searchDebounceHandler: any;
  reviewActionOrderId?: string;
  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals) {

  }

  async ngOnInit() {
    this.periodStart = moment().subtract(2, 'week').toDate();
    this.periodEnd = moment().toDate();
    if (this.globals.storeSettings && this.globals.storeSettings.newOrderFreezeTimeMinutes && this.globals.storeSettings.newOrderFreezeTimeMinutes > 0) {
      this.storeHasFreezeTime = true;
    }
    await this.fetchOrders();
  }

  isInFreezeTime(date) {
    if(moment(date).add(this.globals.storeSettings.newOrderFreezeTimeMinutes, 'minutes').isAfter(moment()))
      return true;
    return false;
  }

  // Orders in a sandbox store are treated as sandbox orders too
  isSandboxOrder(order: IPosterOrder) {
    return !!order.sandbox || !!this.globals.storeSettings.sandbox;
  }

  // E.g. "VOEC: 1 200g, 299 NOK"
  voecSummary(order: IPosterOrder) {
    let format = (value: number) => (value ?? 0).toLocaleString('sv-SE', { maximumFractionDigits: 2 });
    return `VOEC: ${format(order.metadata.weight)}g, ${format(order.metadata.voecData.value)} ${order.metadata.voecData.currency}`;
  }

  async orderNumberKeyUp() {
    if (this.searchDebounceHandler)
      clearTimeout(this.searchDebounceHandler);


    this.searchDebounceHandler = setTimeout(async () => {
      await this.fetchOrders();
    }, 500);
  }

  async requestReclaim(){

  }

  async fetchOrders() {
    this.orders = await this.api.store().get<any>(`/poster-orders?statuses=${this.statuses.join(',')}&orderNumber=${this.orderNumber}&startDate=${moment(this.periodStart).startOf('day').toISOString()}&endDate=${moment(this.periodEnd).endOf('day').toISOString()}`);

    for (let order of this.orders) {
      for (let item of order.items) {
        if (item.status == 'UNKNOWN') {
          (item as any).itemInfo = {
            isStockItem: false,
            posterType: 'POSTER',
            sku: '',
          };
        }
      }
    }

  }


  async printFileAdded(order: IPosterOrder, orderItem: IPosterOrderItem, data: { order: IPosterOrder }) {
    console.log('Print file added');
    console.log(order);
    console.log(orderItem);
    orderItem.status = 'READY';
    order.status = data.order.status;
  }

  async cancelOrder(order: IPosterOrder) {
    await this.api.store().post(`/poster-orders/${order._id}/cancel`, order);
    order.status = 'CANCELLED';
  }

  async runReviewAction(order: IPosterOrder & { reviewActionError?: string }, action: 'submit' | 'produce' | 'fulfill') {
    this.reviewActionOrderId = String(order._id);
    order.reviewActionError = '';
    try {
      const result = await this.api.store().post<any>(`/poster-orders/${order._id}/review-${action}`, {});
      Object.assign(order, result.order);
      if (typeof result.reviewModeCredits === 'number') {
        this.globals.storeSettings.reviewModeCredits = result.reviewModeCredits;
      }
    }
    catch (e: any) {
      order.reviewActionError = e?.error?.message || 'The review-mode action failed.';
    }
    finally {
      this.reviewActionOrderId = undefined;
    }
  }


  async acceptPrintFile(order: IPosterOrder, item: IPosterOrderItem, approvedByHuman: boolean) {
    let result = await this.api.store().post<any>(`/poster-orders/${order._id}/items/${item.identifier}/accept-print-file`, {
      approvedByHuman: approvedByHuman
    });
    if (result.succeeded) {
      Object.assign(order, result.order);
    }
  }

  async addOrderItemInfo(order: IPosterOrder, item: IPosterOrderItem) {
    let itemInfo = (item as any).itemInfo;

    if (this.availableSkuInfoByPosterType[itemInfo.posterType]) {
      let skuInfo = this.availableSkuInfoByPosterType[itemInfo.posterType].find(skuInfo => skuInfo.sku == itemInfo.sku);
      if (skuInfo) {
        itemInfo.size = skuInfo.size;
      }
    }

    if (itemInfo.posterType == 'STOCK_ITEM') {
      itemInfo.isStockItem = true;
    }

    let result = await this.api.store().post<any>(`/poster-orders/${order._id}/items/${item.identifier}/add-info`, itemInfo);
    if (result.succeeded) {
      Object.assign(item, result.orderItem);
    }
  }

  async deleteOrderItem(order: IPosterOrder, item: IPosterOrderItem) {
    let result = await this.api.store().delete<any>(`/poster-orders/${order._id}/items/${item.identifier}`);
    if (result.succeeded) {
      Object.assign(order, result.order);
    }
  }

  async posterTypeChanged(order: IPosterOrder, item: IPosterOrderItem) {

  }

  async skuChanged(order: IPosterOrder, item: IPosterOrderItem) {

  }

  async addOrderItem(order: IPosterOrder) {
    let result = await this.api.store().post<any>(`/poster-orders/${order._id}/items/add`, {});

    if (result.succeeded) {
        order.items.push(result.orderItem);
    }
}

  async search() {


  }



}


